module.exports = __webpack_public_path__ + "static/media/solar-panel.89cf6e57.svg";